import { STATISTICS_OVERVIEW_STORE } from 'store'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { MSLine } from '../MSLine'
import { PeriodChartProps } from './PeriodChart.types'

const PeriodChartComponent = (props: PeriodChartProps) => {
  const {
    [STATISTICS_OVERVIEW_STORE]: {
      periodChartProps
    }
  } = props

  if (!periodChartProps) return null

  return (
    <div>
      <MSLine {...periodChartProps}/>
    </div>
  )
}

const PeriodChart = inject(
  STATISTICS_OVERVIEW_STORE
)(observer(PeriodChartComponent))
export { PeriodChart }
